import type { InputHTMLAttributes, TextareaHTMLAttributes, SelectHTMLAttributes, ReactNode } from "react";

interface FieldProps {
  label: string;
  hint?: string;
  error?: string;
  required?: boolean;
  children: ReactNode;
}

export function Field({ label, hint, error, required, children }: FieldProps) {
  return (
    <label className="block">
      <span className="terminal-label block mb-1.5">
        {label}
        {required && <span className="text-terminal ml-1">*</span>}
      </span>
      {children}
      {hint && !error && (
        <span className="block mt-1 text-2xs text-ink-dim font-mono">{hint}</span>
      )}
      {error && (
        <span className="block mt-1 text-2xs text-status-failed font-mono">! {error}</span>
      )}
    </label>
  );
}

export function Input(props: InputHTMLAttributes<HTMLInputElement>) {
  const { className = "", ...rest } = props;
  return (
    <input
      {...rest}
      className={`w-full bg-void border border-border px-3 py-2 font-mono text-sm text-ink-primary placeholder:text-ink-dim focus:outline-none focus:border-terminal rounded-none ${className}`}
    />
  );
}

export function Textarea(props: TextareaHTMLAttributes<HTMLTextAreaElement>) {
  const { className = "", ...rest } = props;
  return (
    <textarea
      {...rest}
      className={`w-full bg-void border border-border px-3 py-2 font-mono text-sm text-ink-primary placeholder:text-ink-dim focus:outline-none focus:border-terminal rounded-none ${className}`}
    />
  );
}

export function Select(props: SelectHTMLAttributes<HTMLSelectElement>) {
  const { className = "", children, ...rest } = props;
  return (
    <select
      {...rest}
      className={`w-full bg-void border border-border px-3 py-2 font-mono text-sm text-ink-primary focus:outline-none focus:border-terminal rounded-none ${className}`}
    >
      {children}
    </select>
  );
}